import { render, staticRenderFns } from "./CatalogueByCategory.vue?vue&type=template&id=3ad326c7&scoped=true"
import script from "./CatalogueByCategory.vue?vue&type=script&lang=js"
export * from "./CatalogueByCategory.vue?vue&type=script&lang=js"
import style0 from "./CatalogueByCategory.vue?vue&type=style&index=0&id=3ad326c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad326c7",
  null
  
)

export default component.exports